import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, CircularProgress, Grid } from '@mui/material';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';
import * as Yup from 'yup';
import styles from '../Auth/auth.module.scss';
import ArrowRight from '../shared/components/icons/ArrowRight';
import CustomLink from '../shared/components/CustomLink';
import AuthLayout from '../Auth/AuthLayout';
import useApi from '../shared/hooks/useApi';

export default function BidConfirmation() {
  const [error, setError] = useState(false);
  const [isConfirmed, setConfirmed] = useState(false);

  const { bidId, token } = useParams<{ bidId: string; token: string }>();

  const api = useApi();

  const requiredMsg = 'This field cannot be empty.';
  const validationSchema = Yup.object({
    code: Yup.string()
      .matches(/[0-9]{6}/, 'Must be valid 6-digit 2FA code')
      .required(requiredMsg),
  });

  return (
    <AuthLayout title="Confirm Bid" errorMsg={error ? 'Unable to confirm bid.' : ''}>
      {isConfirmed ? (
        <CustomLink label="Bid confirmed" linkText="Log in to your account" linkUrl="/login" />
      ) : (
        <Formik
          initialValues={{
            code: '',
          }}
          validationSchema={validationSchema}
          onSubmit={async ({ code }, { setSubmitting }) => {
            setError(false);
            if (bidId && token) {
              try {
                await api.bid.confirm(bidId, token, code);
                setConfirmed(true);
              } catch (e) {
                setError(true);
              }
            }
            setSubmitting(false);
          }}
        >
          {({ isSubmitting }) => (
            <Form className={styles.form}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Field component={TextField} name="code" label="2FA Code" fullWidth autoFocus />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    size="large"
                    variant="outlined"
                    color="primary"
                    fullWidth
                    endIcon={!isSubmitting && <ArrowRight />}
                  >
                    {isSubmitting ? <CircularProgress /> : 'Confirm'}
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      )}
    </AuthLayout>
  );
}
